// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__0PiUJ","logo":"MainNavigation_logo__4HVUD"};